export const CURRENCIES_DEFAULT = [
  'VND',
  'SGD',
  'USD',
  'RMB',
  'EUR',
  'GBP',
  'MYR',
  'THB',
  'INR',
  'PHP',
];

export enum HTTPStatusCode {
  CONFLICT = 'CONFLICT',
  UNAUTHORIZED = 'UNAUTHORIZED',
  FORBIDDEN = 'FORBIDDEN',
  NOT_FOUND = 'NOT_FOUND',
  SERVER_ERROR = 'SERVER_ERROR',
  BAD_REQUEST = 'BAD_REQUEST',
  UNPROCESSABLE = 'UNPROCESSABLE',
  TOO_MANY_REQUEST = 'TOO_MANY_REQUEST',
}

export const UPLOAD__ALLOWED_IMAGE_EXT = ['png', 'jpg', 'jpeg'];
export const UPLOAD__ALLOWED_DOCUMENT_EXT = [
  'pdf',
  'doc',
  'docx',
  'xlsx',
  'xls',
];

export const ATTACHMENT_TYPE = {
  IMAGE: 'image',
  DOCUMENT: 'document',
};

export const PAGINATION_DEFAULT = {
  pageSize: 20,
  total: 0,
  page: 1,
};

export enum TRADE_ROLE {
  BUYER = 'buyer',
  SELLER = 'seller',
}

export enum USER_ROLES_TEXT {
  staff = 'Staff/Admin',
  member = 'Member',
  agent = 'Agent',
  om = 'OM (Supplier)',
  am = 'Category Lead', // SME-2602
  both = 'Both',
  external = 'External',
  superadmin = 'Superadmin',
}

export enum USER_ROLES {
  staff = 'staff',
  member = 'member',
  agent = 'agent',
  om = 'om',
  am = 'am',
  both = 'both',
  external = 'external',
  superadmin = 'superadmin',
}

export enum USER_TEAMS {
  OPERATIONS = 'OPERATIONS',
  FINANCE = 'FINANCE',
  FINANCE_EXCLUSIVE = 'FINANCE EXCLUSIVE',
}

export const DEVICE = {
  mobile: '(max-width: 600px)',
  tablet: '(max-width: 755px)',
  mobileWidth: '600px',
};
export const MIN_PASSWORD_LENGTH = 10;

export const LOGO =
  'https://sme-assets.sourcesage.co/frontend/sourcesage-logo-with-name-long-256.png';
export const LOGO_FULL = 'https://sourcesage.co/images/ss-logo-text.png';

export enum PriceAlertConditionSymbol {
  lt = '<',
  eq = '==',
  gt = '>',
}
export enum PriceAlertCondition {
  lt = 'Less than',
  eq = 'Equal',
  gt = 'Greater than',
}
export enum PriceAlertNotifyVia {
  email = 1,
  app = 2,
}

export const PriceAlertViaLabel = {
  [PriceAlertNotifyVia.email]: 'Email',
  [PriceAlertNotifyVia.app]: 'App',
};
export const DEFAULT_CALLBACK_LOCALE = 'en';
export const languages: LocaleType[] = ['en', 'vi', 'th', 'zh', 'ja', 'id'];
export const DEFAULT_TOTAL_ANNUAL_REVENUES = '[, 1]';
export const TOTAL_ANNUAL_REVENUES = {
  '[, 1]': 'Below US$1 Million',
  '[1, 10]': 'US$1 Million - US$10 Million',
  '[10, 50]': 'US$10 Million - US$50 Million',
  '[50, 100]': 'US$50 Million - US$100 Million',
  '[100,]': 'Above US$100 Million',
};

export const DEFAULT_TOTAL_EMPLOYEES = '[50, 100]';
export const TOTAL_EMPLOYEES = {
  '[, 50]': 'Fewer Than 50 People',
  '[50, 100]': '50 - 100 People',
  '[100, 501]': '100 - 501 People',
  '[501, 1000]': '501 - 1000 People',
  '[5000,]': 'More Than 5000 People',
};
export const DEFAULT_COUNTRY = 'VN';
export const BUSINESS_TYPES = [
  'Manufacturer',
  'Distributor/Wholesaler',
  'Trading Company',
  'Others',
];
export const PACKAGING_TYPES = [
  '25kg',
  '600kg',
  '700kg',
  '800kg',
  '900kg',
  '1000kg',
  '1200kg',
];
export const TRADE_TERMS = [
  'EXW',
  'FCA',
  'CPT',
  'CIP',
  'DAT',
  'DAP',
  'DDP',
  'FAS',
  'FOB',
  'CFR',
  'CIF',
  'DAF',
  'DES',
  'DEQ',
  'DDU',
];
export const UNITS = [
  'MT',
  'lb',
  'gal',
  'troy ounce',
  'bbl',
  'kg',
  'FCL',
  'l',
  'ml',
  'carton',
];

export const FIVE_MINUTES = 5 * 60 * 1000;
